// This file is auto-generated. Run `pnpm generate:icons` to regenerate.
// biome-ignore-all assist/source/organizeImports: Generated file.
// biome-ignore-all format: Generated file.
// biome-ignore-all lint/a11y/noSvgWithoutTitle: Icon accessibility is handled by the Icon wrapper.
import type { SVGProps } from "react";

export default function MenuHamburgerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 5.28 6.96 C 5.28 6.561 5.601 6.24 6 6.24 H 18 C 18.399 6.24 18.72 6.561 18.72 6.96 C 18.72 7.359 18.399 7.68 18 7.68 H 6 C 5.601 7.68 5.28 7.359 5.28 6.96 Z M 5.28 12 C 5.28 11.601 5.601 11.28 6 11.28 H 18 C 18.399 11.28 18.72 11.601 18.72 12 C 18.72 12.399 18.399 12.72 18 12.72 H 6 C 5.601 12.72 5.28 12.399 5.28 12 Z M 18.72 17.04 C 18.72 17.439 18.399 17.76 18 17.76 H 6 C 5.601 17.76 5.28 17.439 5.28 17.04 C 5.28 16.641 5.601 16.32 6 16.32 H 18 C 18.399 16.32 18.72 16.641 18.72 17.04 Z" fill="currentColor" />
</svg>
  );
}